import {
    SET_PUNCH_OUT_CART_ACTIVE,
    SET_PUNCH_OUT_SESSION_ID,
    SET_PUNCH_OUT_SESSION_IN_PROGRESS,
    SET_PUNCH_OUT_SUPPLIERS,
    SET_PUNCH_OUT_TAB,
} from "../actionTypes";
import { initialState } from "../initialState";

const punchOutReducer = (state = initialState.punchOut, action) => {
    switch (action.type) {
        case SET_PUNCH_OUT_SUPPLIERS:
            return action.payload;
        case SET_PUNCH_OUT_SESSION_ID:
            return {
                ...state,
                punchOutSessionId: action.payload,
            };
        case SET_PUNCH_OUT_SESSION_IN_PROGRESS:
            return {
                ...state,
                punchOutSessionInProgress: action.payload,
            };
        case SET_PUNCH_OUT_CART_ACTIVE:
            return {
                ...state,
                punchOutCartActive: action.payload,
            };
        case SET_PUNCH_OUT_TAB:
            return {
                ...state,
                punchOutTab: action.payload,
            };
        default:
            return state;
    }
};

export default punchOutReducer;
